import * as React from 'react'
import {format} from 'date-fns'
import {
  capitalizeFirstLetter,
  snakeCaseToSpaces
} from '@frontrow/console/src/entities/helpers/string-helper'
import {Button} from '@frontrow/console/src/components/button'
import {type LicenseT} from '@frontrow/console/src/entities/models/license'

import DeleteLicenseButtonModal from '@frontrow/console/src/components/common/school-licenses-list/license-row/delete-license-button-modal'
import * as style from './license-row.module.scss'

type Props = {
  license: LicenseT
  schoolName: string
  removeLicense: (licenseId: number) => void
  duplicateLicense: (license: LicenseT) => void
  enableModifications: boolean
}

export default function LicensesRow(props: Props): React.ReactElement {
  const {license, schoolName, removeLicense, duplicateLicense, enableModifications} = props

  const startDateDetail = format(license.startsAt, 'MM/dd/yyyy')
  const endDateDetail = format(license.expiresAt, 'MM/dd/yyyy')
  const subjectDetail = `${capitalizeFirstLetter(
    snakeCaseToSpaces(license.subject)
  )}: ${license.count}`

  return (
    <div className={style.licenseDetailContainer}>
      <DeleteLicenseButtonModal
        schoolName={schoolName}
        startDateDetail={startDateDetail}
        endDateDetail={endDateDetail}
        subjectDetail={subjectDetail}
        removeLicense={() => removeLicense(license.id)}
        enableModifications={enableModifications}
      />
      <div className={style.licenseDetail}>{startDateDetail}</div>
      <div className={style.licenseDetail}>{endDateDetail}</div>
      <div className={style.licenseDetail}>{subjectDetail}</div>
      <Button
        style="link"
        onClick={() => duplicateLicense(license)}
        disabled={!enableModifications}
      >
        <i className="fa fa-copy fa-lg" />
        Duplicate License
      </Button>
    </div>
  )
}
